// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1aadaeba","879":"6d02f7f1"}[chunkId] + ".chunk.js";
};